import { render, staticRenderFns } from "./NavNotifications.vue?vue&type=template&id=131ba7ec&scoped=true&"
import script from "./NavNotifications.vue?vue&type=script&lang=ts&"
export * from "./NavNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./NavNotifications.vue?vue&type=style&index=0&id=131ba7ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131ba7ec",
  null
  
)

export default component.exports